import React from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';

import { rewardsBanner } from 'styles/components/account/rewardsBanner.scss';

function getContentPrefix(prime, justLinked) {
  if (prime && justLinked) {
    return 'justLinked';
  } else if (prime) {
    return 'previouslyLinked';
  } else {
    return 'notLinked';
  }
}

// displays certain banners if they just linked
const RewardsPrimeBanner = ({ prime, justLinked, content }, { marketplace }) => {
  const { authUrl } = marketplace;
  const prefix = getContentPrefix(prime, justLinked);
  const mobileImg = content[`${prefix}ImgMobile`];
  const tabletImg = content[`${prefix}ImgTablet`];
  const description = content[`${prefix}Description`];
  const desktopImg = content[`${prefix}Img`];
  const retinaImg = content[`${prefix}ImgRetina`];

  return prefix === 'notLinked' ? (
    <Link to={`${authUrl}/rewards/dashboard`}>
      <picture>
        <source media={'(max-width: 650px)'} srcSet={mobileImg} />
        <source media={'(max-width: 1024px)'} srcSet={tabletImg} />
        <img
          className={rewardsBanner}
          src={desktopImg}
          srcSet={`${retinaImg} 2x, ${desktopImg} 1x`}
          alt={description}
        />
      </picture>
    </Link>
  ) : (
    <picture>
      <source media={'(max-width: 650px)'} srcSet={mobileImg} />
      <source media={'(max-width: 1024px)'} srcSet={tabletImg} />
      <img
        className={rewardsBanner}
        src={desktopImg}
        srcSet={`${retinaImg} 2x, ${desktopImg} 1x`}
        alt={description}
      />
    </picture>
  );
};

RewardsPrimeBanner.contextTypes = {
  marketplace: PropTypes.object
};

export default RewardsPrimeBanner;
